import { create } from "zustand";
import { axiosHelper, tokenHelper } from "../helpers";
import { filterNonFalseValues } from "../helpers/Utlis";

export const useSpaceStore = create((set, get) => ({
  spaces: [],
  subspaces: [],
  pagination: null,
  space: null,
  isLoading: false,
  isLoadingSpace: false,
  isLoadingSubspaces: false,
  isError: false,
  error: undefined,
  lastQuery: {
    siteId: null,
    page: 1,
    perPage: 10,
    search: "",
  },
  lastSubSpaceQuery: {
    spaceId: null,
    page: 1,
    limit: 10,
  },
  filters: {
    code: "",
    DestProv: "",
    dateFrom: "",
    dateTo: "",
    access: "",
    driverId: "",
    charger: false,
  },
  // Methods
  createSpace: async (siteID, body, kitchenID, menuIDs) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.post(
        `/v2/space/create`,
        {
          ...body,
          site_id: siteID,
          kitchen_id: kitchenID,
          menu_ids: menuIDs,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      //create QR code
      if (response.space_id) {
        const qrResponse = await axiosHelper.post(
          "/qr/create",
          {
            kitchen_id: kitchenID,
            space_id: response.space_id,
            menu_ids: menuIDs,
          },
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
      }

      // //linken the space to the kitchen
      // const response2 = await axiosHelper.post(
      //   `/kitchen/${kitchenID}/link-space/${response.space_id}`,
      //   body,
      //   {
      //     headers: { Authorization: `Bearer ${accessToken}` },
      //   }
      // );
      // const response3 = await axiosHelper.patch(
      //   `/menu/${menuID}/link-space/${response.space_id}`,
      //   body,
      //   {
      //     headers: { Authorization: `Bearer ${accessToken}` },
      //   }
      // );

      // Refresh the list with last query params
      const { siteId, page, perPage, search } = get().lastQuery;
      await get().getSpaces(siteId || siteID, { page, perPage, search });

      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  getSubSpaces: async (spaceID, page = 1, limit = 10) => {
    try {
      set({ isLoadingSubspaces: true, isError: false });

      // Save query params for later use
      set({ lastSubSpaceQuery: { spaceId: spaceID, page, limit } });

      const accessToken = await tokenHelper.getToken();

      const [subSpaceRes, qrRes] = await Promise.all([
        axiosHelper.get(
          `/sub-space/space/${spaceID}?page=${page}&perPage=${limit}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(`/qr/space/${spaceID}`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        }),
      ]);

      const subspacesData = subSpaceRes?.data || [];
      const qrResponse = qrRes || [];
      const pagination = subSpaceRes?.pagination;

      const combinedSubSpaces = subspacesData.map((subspace) => {
        const matchingQR = qrResponse.find(
          (qr) => qr?.sub_space_id === subspace?.sub_space_id
        );
        return {
          ...subspace,
          qrKey: matchingQR?.key || null,
        };
      });

      set({
        subspaces: combinedSubSpaces,
        pagination,
        isLoadingSubspaces: false,
        isError: false,
      });

      return combinedSubSpaces;
    } catch (e) {
      set({ isLoadingSubspaces: false, isError: true, error: e.message });
      console.log(e);
      throw e;
    }
  },

  createSubSpaces: async (spaceID, body, kitchenID, menuIDs) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post(
        `/sub-space/create-many`,
        {
          ...body,
          kitchen_id: kitchenID,
          menu_ids: menuIDs,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );


      // Refresh subspaces with last query params
      const { spaceId, page, limit } = get().lastSubSpaceQuery;
      await get().getSubSpaces(spaceId || spaceID, page, limit);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  deleteSubSpace: async (space_id, subSpaceID) => {
    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.delete(
        `/sub-space/${parseInt(subSpaceID)}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      // Refresh with last query params
      const { spaceId, page, limit } = get().lastSubSpaceQuery;
      get().getSubSpaces(spaceId || space_id, page, limit);

      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  },
  updateSubSpace: async (spaceID, subSpaceID, body) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.patch(
        `/sub-space/${subSpaceID}`,
        {
          ...body,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      // Refresh with last query params
      const { spaceId, page, limit } = get().lastSubSpaceQuery;
      get().getSubSpaces(spaceId || spaceID, page, limit);
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  getSpace: async (spaceID) => {
    try {
      set({ isLoadingSpace: true, isError: false });
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.get(`v2/space/${parseInt(spaceID)}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      set({ isLoadingSpace: false, space: response, isError: false });
      return response;
    } catch (err) {
      console.log(err);
      set({ isLoadingSpace: false, isError: true, error: err.message });
      throw err;
    }
  },
  getSpaces: async (siteID, { page, perPage, search = "" }) => {
    const requestId = (get()._spacesListRequestId || 0) + 1;
    set({ _spacesListRequestId: requestId });

    try {
      // Early exit if siteID is not provided
      if (!siteID) {
        if (get()._spacesListRequestId === requestId) {
          set({ spaces: [], isLoading: false });
        }
        return;
      }

      set({ isLoading: true });

      // Save query params for later use
      set({ lastQuery: { siteId: siteID, page, perPage, search } });

      const accessToken = await tokenHelper.getToken();

      const params = new URLSearchParams({ page, PerPage: perPage });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }

      // Single list request — menu_ids and qrKey come from the spaces payload
      const spaceResponse = await axiosHelper.get(
        `/v2/site/${siteID}/spaces?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      );

      if (get()._spacesListRequestId !== requestId) return;

      const combinedSpaces = (spaceResponse?.spaces || []).map((space) => ({
        ...space,
        menu_ids: space.menu_ids || [],
        qrKey: space.qrKey ?? null,
      }));

      set({
        spaces: combinedSpaces,
        pagination: spaceResponse?.pagination,
        isLoading: false,
      });

      return combinedSpaces;
    } catch (error) {
      if (get()._spacesListRequestId !== requestId) return false;
      console.error("Error fetching spaces:", error);
      set({ spaces: [], isLoading: false });
      return false;
    }
  },

  //get paged spaces for the current user
  getUserSpaces: async (page = 1, limit = 10) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();

      // Get all spaces for the current user
      const response = await axiosHelper.get(`/v2/space?page=${page}&perPage=${limit}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      set({
        spaces: response.spaces || response,
        isLoading: false,
      });

      return response.spaces || response;
    } catch (error) {
      console.error("Error fetching user spaces:", error);
      set({ spaces: [], isLoading: false });
      return [];
    }
  },

  updateSite: async (id, info) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();

      let response = await axiosHelper.patch(`/site/${id}`, info, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Refresh with last query params
      const { siteId, page, perPage, search } = get().lastQuery;
      if (siteId) {
        get().getSpaces(siteId, { page, perPage, search });
      }
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  updateSpace: async (id, info, selectedSite) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();

      let response = await axiosHelper.patch(`/v2/space/${id}`, info, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Refresh with last query params
      const { siteId, page, perPage, search } = get().lastQuery;
      get().getSpaces(siteId || selectedSite, { page, perPage, search });
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  deleteSpace: async (space_id, siteID) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();

      let response = await axiosHelper.delete(`/v2/space/${space_id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Refresh with last query params
      const { siteId, page, perPage, search } = get().lastQuery;
      get().getSpaces(siteId || siteID, { page, perPage, search });

      return true;
    } catch (e) {
      console.log(e);

      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  setFilters: (filters) => {
    set({ filters: filterNonFalseValues(filters) });
  },
}));
